import { type InfiniteData, infiniteQueryOptions } from '@tanstack/react-query';

import { API_SERVICE } from '@/constants/api.constant';
import { GET } from '@/lib/fetch';
import type { NotificationResponse } from '@/types/notification/notification';
import type { DataTableQuery } from '@/types/request';
import type { DataTableResponse, ErrorApiResponse } from '@/types/response';

export const notificationQueries = {
	keys: () => 'notifications' as const,
	list: (query: DataTableQuery) =>
		infiniteQueryOptions<
			DataTableResponse<NotificationResponse>,
			ErrorApiResponse,
			InfiniteData<DataTableResponse<NotificationResponse>>,
			readonly ['notifications', 'list', DataTableQuery],
			DataTableQuery
		>({
			queryKey: [notificationQueries.keys(), 'list', query],
			queryFn: ({ pageParam }) =>
				GET({
					path: '/notifications',
					query: pageParam,
					service: API_SERVICE.API
				}),
			initialPageParam: query,
			getNextPageParam: (lastPage, _data, lastPageParam) => {
				if (
					!lastPage.data ||
					(lastPageParam.pageSize && lastPage.data.length < lastPageParam.pageSize)
				) {
					return null;
				}

				return {
					...lastPageParam,
					pageNumber: (lastPageParam.pageNumber ?? 0) + 1
				};
			},
			refetchInterval: 1000 * 30
		})
};
